import type { PluginTypeOrderParams } from '../params/PluginTypeParams.ts';

type GetOrderRootProps = PluginTypeOrderParams;

type GetOrderRootPropsSuccessResult = {
  success: true;
  props: GetOrderRootProps;
};

type GetOrderRootPropsErrorResult = {
  success: false;
  error: string;
};

export type GetOrderRootPropsResult =
  | GetOrderRootPropsSuccessResult
  | GetOrderRootPropsErrorResult;

export const getOrderRootProps = (
  params: PluginTypeOrderParams,
): GetOrderRootPropsResult => {
  return { success: true, props: params };
};
